'use client';

import { createContext, useContext } from 'react';

export interface ExperimentOfferData {
  offerId: string;
  isMonetizing: boolean;
  directApplyLink?: string;
  institution: { id: string; name: string };
  product: { id: string; name: string };
}

const ExperimentOfferContext = createContext<ExperimentOfferData | null>(null);

export const ExperimentOfferProvider = ({
  value,
  children,
}: {
  value: ExperimentOfferData | null;
  children: React.ReactNode;
}) => {
  return (
    <ExperimentOfferContext.Provider value={value}>{children}</ExperimentOfferContext.Provider>
  );
};

export function useExperimentOfferContext(): ExperimentOfferData | null {
  return useContext(ExperimentOfferContext);
}
